import axios from "../conf/axios.default";
import { logError } from "./log";

export const createContract = async (customerId, data) => {
  let url = "/customers/" + customerId + "/contracts";

  try {
    let res = await axios.post(url, data);
    return res.data;
  } catch (err) {
    logError(err);
    return null;
  }
};

export const createContractDocument = async (customerId, contractId, data) => {
  let url = `/customers/${customerId}/contracts/${contractId}/documents`;

  try {
    let res = await axios.post(url, data);
    return res.data;
  } catch (err) {
    logError(err);
    return null;
  }
};
